import React from 'react';
import { ArrowLeft } from 'lucide-react';
import AdsButton from './AdsButton';

/**
 * Canonical Retour / Back — same AdsButton chrome as secondary peers.
 */
const AdsBackButton = ({
  children,
  onClick,
  className = '',
  size = 'sm',
  type = 'button',
  onDark = false,
  'aria-label': ariaLabel,
  ...props
}) => {
  const classes = [
    'ads-back-btn',
    onDark ? 'ads-back-btn--on-dark' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <AdsButton
      type={type}
      variant="secondary"
      size={size}
      className={classes}
      onClick={onClick}
      aria-label={ariaLabel}
      {...props}
    >
      <ArrowLeft size={size === 'sm' ? 16 : 18} className="ads-icon-dir" aria-hidden />
      {children}
    </AdsButton>
  );
};

export default AdsBackButton;
